import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from '../utils/axiosInstance'
import { toast } from 'react-toastify';

const initialState = {
  loading: false,
  instagramAC: [],
  redditAC: [],
  cookies: [],
  cookieCount: 0,
  youtubes: [],
  youtubeCount: 0,
  count:0,
  next: null,
  previous: null,
  total_pages: 0,
  error: {},
}
//  Instagram Cookie thunks
export const fetchinstagramAC = createAsyncThunk('cookieSlice/fetchinstagramAC', async (queyString, thunkAPI) => {
  
  try {
    const response = await axiosInstance.get(`/ig/cookies${queyString ?queyString :''}`);
    return response.data; 
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch roles');
  }
});

export const deleteInstagramAC = createAsyncThunk('cookieSlice/deleteInstagramAC', async (id, thunkAPI) => {

  try {
    const response = await axiosInstance.delete(`/ig/cookies/${id}`);
    response.data = id
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});


export const createInstagramAC = createAsyncThunk('cookieSlice/createInstagramAC', async (values, thunkAPI) => {

  try {
    const response = await axiosInstance.post('/ig/cookies/generate', values);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

export const toggleActivationInstagramAC = createAsyncThunk('cookieSlice/toggleActivationInstagramAC', async (id, thunkAPI) => {

  try {
    const response = await axiosInstance.post(`/ig/cookies/${id}/toggle-activation`);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete role');
  }
});

//  Reddit Cookie thunks
export const fetchRedditAC = createAsyncThunk('cookieSlice/fetchRedditAC', async (queryString, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/reddit/client${queryString ? queryString : ''}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch Reddit cookies');
  }
});

export const createRedditAC = createAsyncThunk('cookieSlice/createRedditAC', async (values, thunkAPI) => {
  try {
    const response = await axiosInstance.post('/reddit/client', values);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to create Reddit cookie');
  }
});

export const updateRedditAC = createAsyncThunk('cookieSlice/updateRedditAC', async ({ id, values }, thunkAPI) => {
  try {
    const response = await axiosInstance.patch(`/reddit/client/${id}`, values);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to update Reddit cookie');
  }
});

export const deleteRedditAC = createAsyncThunk('cookieSlice/deleteRedditAC', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/reddit/client/${id}`);
    response.data = id;
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete Reddit cookie');
  }
});

export const toggleActivationRedditAC = createAsyncThunk('cookieSlice/toggleActivationRedditAC', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/reddit/client/${id}/toggle-activation`);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to toggle Reddit cookie activation');
  }
});

// Facebook Cookie thunks
export const fetchCookies = createAsyncThunk('cookieSlice/fetchCookies', async (queyString, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/fb/cookies${queyString ? queyString : ''}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch cookies');
  }
});
export const generateCookie = createAsyncThunk('cookieSlice/generateCookie', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/fb/cookies/generate`, payload);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to generate cookie');
  }
});
export const deleteCookie = createAsyncThunk('cookieSlice/deleteCookie', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/fb/cookies/${id}`);
    response.data = id
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete cookie');
  }
});
export const cookieToggleActivation = createAsyncThunk('cookieSlice/cookieToggleActivation', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/fb/cookies/${id}/toggle-activation`);
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to toggle cookie activation');
  }
});

// YouTube thunks
export const fetchYoutubes = createAsyncThunk('cookieSlice/fetchYoutubes', async (queryString, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/youtube/api-key${queryString ? queryString : ''}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to fetch youtubes');
  }
});
export const generateYoutube = createAsyncThunk('cookieSlice/generateYoutube', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/youtube/api-key`, payload);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to generate youtube');
  }
});
export const updateYoutube = createAsyncThunk('cookieSlice/updateYoutube', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.patch(`/youtube/api-key/${payload?.id}`, payload);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to update youtube');
  }
});
export const deleteYoutube = createAsyncThunk('cookieSlice/deleteYoutube', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/youtube/api-key/${id}`);
    response.data = id;
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to delete youtube');
  }
});
export const youtubeToggleActivation = createAsyncThunk('cookieSlice/youtubeToggleActivation', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/youtube/api-key/${id}/toggle-activation`);
    return response;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to toggle activation');
  }
});
export const setYoutubeActiveStatus = createAsyncThunk('cookieSlice/setYoutubeActiveStatus', async ({ id, active }, thunkAPI) => {
  try {
    const response = await axiosInstance.post(`/youtube/api-key/${id}/set-active`, { active });
    return { ...response.data, id, active };
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || 'Failed to set YouTube active status');
  }
});

export const cookieSlice = createSlice({
  name: 'cookieSlice',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    // fetch contacts
    builder.addCase(fetchinstagramAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchinstagramAC.fulfilled, (state, action) => {
      console.log("action.payload",action.payload);
      state.instagramAC = action.payload?.data?.results;
      state.next = action.payload?.data?.next;
      state.total_pages = action.payload?.data?.total_pages;
      state.previous = action.payload?.data?.previous;
      state.count = action.payload?.data?.count;
      state.loading = false;
    });
    builder.addCase(fetchinstagramAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //create contacts
    builder.addCase(createInstagramAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createInstagramAC.fulfilled, (state, action) => {
      state.loading = false;
      // state.instagramAC = [action?.payload?.data.data,...state.instagramAC];
      // if(action?.payload?.status==202){
      //   toast.success("Completed Successfully")
      // }
    });
    builder.addCase(createInstagramAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteInstagramAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteInstagramAC.fulfilled, (state, action) => {
      state.loading = false;
      state.instagramAC = state.instagramAC.filter((ele)=>ele.uuid !==action?.payload?.data);
      if(action?.payload?.status==204){
        toast.success("Instagram account deleted successfully")
      }
    });
    builder.addCase(deleteInstagramAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // active incative contact
    builder.addCase(toggleActivationInstagramAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(toggleActivationInstagramAC.fulfilled, (state, action) => {
      console.log("action",action);
      const id=action?.payload?.data?.data?.id;
      state.instagramAC = state.instagramAC.map(platform =>
        platform.id === id ? action?.payload?.data?.data : platform
      );  
      state.loading = false;
      state.error = null;
      if(action?.payload?.status==200){
        toast.success("Instagram Account updated successfully")
      }
    });
    builder.addCase(toggleActivationInstagramAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Reddit cases
    builder.addCase(fetchRedditAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchRedditAC.fulfilled, (state, action) => {
      state.redditAC = action.payload?.data?.results;
      state.next = action.payload?.data?.next;
      state.total_pages = action.payload?.data?.total_pages;
      state.previous = action.payload?.data?.previous;
      state.count = action.payload?.data?.count;
      state.loading = false;
    });
    builder.addCase(fetchRedditAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(createRedditAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createRedditAC.fulfilled, (state, action) => {
      state.loading = false;
      state.redditAC = [action?.payload?.data.data, ...state.redditAC];
      if (action?.payload?.status == 201) {
        toast.success('Reddit account created successfully');
      }
    });
    builder.addCase(createRedditAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(updateRedditAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateRedditAC.fulfilled, (state, action) => {
      const updated = action?.payload?.data?.data;
      if (action?.payload?.status == 200) {
        state.redditAC = state.redditAC.map(item => item.id === updated.id ? updated : item);
        toast.success('Reddit account updated successfully');
      }
      state.loading = false;
    });
    builder.addCase(updateRedditAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteRedditAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteRedditAC.fulfilled, (state, action) => {
      state.loading = false;
      state.redditAC = state.redditAC.filter((ele) => ele.uuid !== action?.payload?.data);
      if (action?.payload?.status == 204) {
        toast.success('Reddit account deleted successfully');
      }
    });
    builder.addCase(deleteRedditAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(toggleActivationRedditAC.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(toggleActivationRedditAC.fulfilled, (state, action) => {
      const id = action?.payload?.data?.data?.id;
      state.redditAC = state.redditAC.map(item => item.id === id ? action?.payload?.data?.data : item);
      state.loading = false;
      state.error = null;
      if (action?.payload?.status == 200) {
        toast.success('Reddit account updated successfully');
      }
    });
    builder.addCase(toggleActivationRedditAC.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // Facebook Cookie cases
    builder.addCase(fetchCookies.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchCookies.fulfilled, (state, action) => {
      state.cookies = action.payload?.data?.results;
      state.cookieCount = action.payload?.data?.count;
      state.next = action.payload?.data?.next;
      state.total_pages = action.payload?.data?.total_pages;
      state.previous = action.payload?.data?.previous;
      state.loading = false;
    });
    builder.addCase(fetchCookies.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(generateCookie.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(generateCookie.fulfilled, (state, action) => {
      state.loading = false;
      // if (action?.payload?.status == 201) {
      //   toast.success('Facebook cookie created successfully');
      // }
    });
    builder.addCase(generateCookie.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteCookie.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteCookie.fulfilled, (state, action) => {
      state.loading = false;
      state.cookies = state.cookies.filter((ele) => ele.uuid !== action?.payload?.data);
      if (action?.payload?.status == 204) {
        toast.success('Facebook account deleted successfully');
      }
    });
    builder.addCase(deleteCookie.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(cookieToggleActivation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(cookieToggleActivation.fulfilled, (state, action) => {
      console.log("action",action);
      const id=action?.payload?.data?.data?.id;
      state.cookies = state.cookies.map(cookie =>
        cookie.id === id ? action?.payload?.data?.data : cookie
      );  
      state.loading = false;
      state.error = null;
      if(action?.payload?.status==200){
        toast.success("Facebook account updated successfully")
      }
    });
    builder.addCase(cookieToggleActivation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // YouTube cases
    builder.addCase(fetchYoutubes.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchYoutubes.fulfilled, (state, action) => {
      state.youtubes = action.payload?.data?.results;
      state.youtubeCount = action.payload?.data?.count;
      state.next = action.payload?.data?.next;
      state.total_pages = action.payload?.data?.total_pages;
      state.previous = action.payload?.data?.previous;
      state.loading = false;
    });
    builder.addCase(fetchYoutubes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(generateYoutube.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(generateYoutube.fulfilled, (state, action) => {
      state.loading = false;
      state.youtubes = [action?.payload?.data.data, ...state.youtubes];
      if (action?.payload?.status == 201) {
        toast.success('YouTube account created successfully');
      }
    });
    builder.addCase(generateYoutube.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(updateYoutube.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(updateYoutube.fulfilled, (state, action) => {
      const updated = action?.payload?.data?.data;
      if (action?.payload?.status == 200) {
        state.youtubes = state.youtubes.map(item => item.id === updated.id ? updated : item);
        toast.success('YouTube account updated successfully');
      }
      state.loading = false;
    });
    builder.addCase(updateYoutube.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(deleteYoutube.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteYoutube.fulfilled, (state, action) => {
      state.loading = false;
      state.youtubes = state.youtubes.filter((ele) => ele.uuid !== action?.payload?.data);
      if (action?.payload?.status == 204) {
        toast.success('YouTube account deleted successfully');
      }
    });
    builder.addCase(deleteYoutube.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(youtubeToggleActivation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(youtubeToggleActivation.fulfilled, (state, action) => {
      const id = action?.payload?.data?.data?.id;
      state.youtubes = state.youtubes.map(item => item.id === id ? action?.payload?.data?.data : item);
      state.loading = false;
      state.error = null;
      if (action?.payload?.status == 200) {
        toast.success('YouTube account updated successfully');
      }
    });
    builder.addCase(youtubeToggleActivation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(setYoutubeActiveStatus.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(setYoutubeActiveStatus.fulfilled, (state, action) => {
      const updated = action?.payload?.data?.data;
      if (action?.payload?.status == 200) {
        state.youtubes = state.youtubes.map(item => item.id === updated.id ? updated : item);
        toast.success('YouTube account active status updated successfully');
      }
      state.loading = false;
    });
    builder.addCase(setYoutubeActiveStatus.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
})


export default cookieSlice.reducer